import { useAtomValue } from 'jotai'
import { useFormatter } from 'next-intl'

import { userAtom } from '@/global-state'

export const useFormatDate = () => {
	const formatter = useFormatter()
	const user = useAtomValue(userAtom)
	const timeZone =
		user?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone

	return (date: Date | number | string) => {
		const normalizedDate = date instanceof Date ? date : new Date(date)

		return formatter.dateTime(normalizedDate, {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			timeZone,
		})
	}
}

export const useFormatDateRange = (
	startDate: Date | number | string,
	endDate: Date | number | string,
	timeZone?: string,
) => {
	const format = useFormatter()

	const normalizedStartDate =
		startDate instanceof Date ? startDate : new Date(startDate)
	const normalizedEndDate =
		endDate instanceof Date ? endDate : new Date(endDate)

	return format.dateTimeRange(normalizedStartDate, normalizedEndDate, {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
		...(timeZone && { timeZone }),
	})
}
